const tables = [
  {
    name: "Name",
  },
  {
    name: "Title",
  },
  {
    name: "Author",
  },
  {
    name: "Date",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
